import React, { useMemo } from "react";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { defaultBaseColor } from "../constants";
import { CssBaseline } from "@mui/material";
import "../assets/fonts"; // Import the fonts
import glacialRegular from "../assets/fonts/GlacialIndifference-Regular.otf";

function Theme({ children }) {
    const baseColor = window.defaultTheme["base-color"] || defaultBaseColor;

    // Memoize theme creation to prevent unnecessary recalculations
    const theme = useMemo(() => {
        return createTheme({
            palette: {
                primary: {
                    main: baseColor,
                },
                // lowering the contrast threshold from the default 3.0 to make white the contrast for our default color
                contrastThreshold: 2.7,
            },
            components: {
                MuiCssBaseline: {
                    styleOverrides: {
                        "@font-face": {
                            fontFamily: "Glacial",
                            src: `url(${glacialRegular})`,
                            fontWeight: "normal",
                            fontStyle: "normal",
                        },
                        a: {
                            color: baseColor,
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline",
                            },
                        },
                    },
                },
                MuiOutlinedInput: {
                    styleOverrides: {
                        root: {
                            backgroundColor: "white",
                        },
                    },
                },
                MuiTextField: {
                    defaultProps: {
                        variant: "outlined",
                    },
                },
                MuiSelect: {
                    defaultProps: {
                        variant: "outlined",
                    },
                },
            },
        });
    }, [baseColor]);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
}

export default Theme;
